export default "__VITE_PUBLIC_ASSET__32affe9a__"